import React from 'react';
import {useConfig} from "../../../context/ConfigContext";


const Logo = (props) => {
  const { config } = useConfig();
  const base_media_url = config?.base_media_url;
  let logoUrl = "https://s3.emmezeta.hr/falcon/emmezeta_logo.svg"

  if (config?.header_logo_src) {
    const configLogoUrl = config?.header_logo_src;
    logoUrl = !configLogoUrl.startsWith('http') ? `${base_media_url}logo/${configLogoUrl}` : configLogoUrl;
  }

  return (
    <img src={logoUrl} {...props} alt="Logo"/>
  );
};

export default Logo;